import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { notifyOnEventSSE } from "../pages/QuotationChat/api/markEventAsRead";
import { useApoAuth } from ".";

export function useChatEventNotifications() {
  const { source_entity, user, isAuthenticated } = useApoAuth();
  const dispatch = useDispatch();

  const setUnreadEventsByUsername = useCallback(
    (evtUid: string, roomUid: string) => {
      dispatch({ type: "SET_UNREAD_EVENTS_BY_USERNAME", eventId: evtUid, roomUid });
    },
    [dispatch],
  );

  useEffect(() => {
    if (!isAuthenticated) return;
    if (!source_entity) return;
    if (!user?.email) return;

    const evtSource = notifyOnEventSSE(
      source_entity,
      user.email,

      () => {}, // General events handler (not used for chat)
      setUnreadEventsByUsername, // Chat message handler
    );

    // Cleanup: close SSE connection on unmount
    return () => {
      evtSource.close();
    };
  }, [isAuthenticated, source_entity, user?.email, setUnreadEventsByUsername]);
}
